var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreativeTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mr-2",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.937338 0.941761L0.935085 0.944006C0.800808 1.07794 0.693586 1.23648 0.619274 1.41096C0.537968 1.60888 0.500004 1.80251 0.500004 2V12V12.0009C0.499632 12.1983 0.538492 12.3939 0.614326 12.5761C0.690159 12.7584 0.801456 12.9238 0.941755 13.0626L0.94429 13.0652C1.08232 13.2038 1.24652 13.3136 1.42734 13.3883C1.60817 13.4629 1.80202 13.5009 1.99763 13.5H1.99993H13.9995C14.1473 13.5 14.2882 13.4345 14.3848 13.3193C14.3849 13.3192 14.385 13.319 14.3852 13.3189L19.3841 7.32001C19.3841 7.31997 19.3841 7.31994 19.3841 7.3199C19.5386 7.13433 19.5386 6.86466 19.3841 6.67908C19.3841 6.67904 19.3841 6.67901 19.3841 6.67898L14.3859 0.680909C14.3856 0.680657 14.3854 0.680405 14.3852 0.680153C14.2884 0.565542 14.1473 0.500004 13.9995 0.500004L1.99993 0.500004L1.99899 0.500003C1.80159 0.499631 1.60608 0.538491 1.42383 0.614326C1.24158 0.690161 1.07621 0.801459 0.937338 0.941761Z",
    stroke: "#89929E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#89929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeTagIcon);
export default __webpack_public_path__ + "static/media/creative_tag_icon.e2a37445d9dfeb018bb8bb2d87a720b3.svg";
export { ForwardRef as ReactComponent };